import React, {FC} from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import {
  BusinessSchedule as BusinessScheduleProto,
  Recurrence as RecurrenceProto,
} from '@wix/ambassador-table-reservations-v1-experience/types'

import {getShortDate} from '../../utils/dateString'

interface Props {
  className?: string
  businessSchedule?: BusinessScheduleProto
  regionalSettings?: string
}

export const ExperienceSchedule: FC<Props> = ({className, businessSchedule, regionalSettings}) => {
  const {t} = useTranslation()
  const {isSSR} = useEnvironment()

  if (businessSchedule && businessSchedule.entries && businessSchedule.entries.length) {
    const multipleBusinessScheduleEntries = businessSchedule.entries.length > 1
    const businessScheduleEntry = businessSchedule.entries[0]
    const weeklyRecurrence = businessScheduleEntry?.recurrence === RecurrenceProto.WEEKLY

    if (multipleBusinessScheduleEntries || weeklyRecurrence) {
      return (
        <Text className={className}>
          {t('uou-reservations.experiences.schedule.multiple-dates')}
        </Text>
      )
    }

    const oneTimeOptions = businessScheduleEntry?.oneTimeOptions
    const dateString = `${oneTimeOptions?.startDate}T${oneTimeOptions?.startTime}`

    return (
      <Text className={className}>
        {isSSR ? dateString : getShortDate(new Date(dateString), regionalSettings)}
      </Text>
    )
  }

  return (
    <Text className={className}>
      {t('uou-reservations.experiences.schedule.date-and-time-tbd')}
    </Text>
  )
}
